var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('html',[_c('head'),_c('body',[_c('h2',[_vm._v("MJP 的 Application")]),_c('p',[_vm._v("每一类 Application 都可以独立进行配置。")]),_c('p',[_vm._v("Application 的配置文件中的同名部分会被 Instance 覆盖。")])])])])
}]

export { render, staticRenderFns }